<template>
  <div>
    <IOSSNumbersHead
        :showFilter="showFilter"
        :countFilterParams="countFilterParams"
        @toggleFilter="toggleFilter"
        @filter="$emit('filter')"
        @changeFilter="changeFilter"
        @selectAll="selectAll"
        @reloadTable="$emit('reloadTable')"
    />

    <div class="table-filter-wrap">

      <IOSSNumbersFilter
          :showFilter="showFilter"
          :filterGetParams="filterGetParams"
          :countFilterParams="countFilterParams"
          @close="closeFilter"
          @changeFilter="changeFilter"
          @resetFilter="$emit('resetFilter')"
      />

      <IOSSNumbersTable
          :countFilterParams="countFilterParams"
          @showMore="$emit('showMore')"
          @resetFilter="$emit('resetFilter')"
          :selectedNow="selectedNow"
      />
    </div>
  </div>
</template>

<script>


  import IOSSNumbersHead from "./IOSSNumbersHead/IOSSNumbersHead";
  import IOSSNumbersTable from "./IOSSNumbersTable/IOSSNumbersTable";
  import IOSSNumbersFilter from "./IOSSNumbersFilter/IOSSNumbersFilter";

  export default {
    name: "IOSSNumbersTableUser",

    components: {
      IOSSNumbersHead,
      IOSSNumbersTable,
      IOSSNumbersFilter,
    },

    props: {
      countFilterParams: Number,
      filterGetParams: Object,
    },

    data(){
      return{
        showFilter: false,
        filterId: '',
        filterName: '',

        selectedNow: false,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },

      changeShopType(index) {
        this.$emit('changeShopType', index)
      },


      changeFilter(data) {
        console.log(data);
        this.$emit('changeFilter', data)
      },

      selectAll(val) {
        this.selectedNow = val
      },
    }
  }
</script>

<style scoped>

</style>
